import { toast } from "sonner";
import request from "../../helpers/request";

interface IRequestLogin {
  user: string;
  pass: string;
}

const login = async (params: IRequestLogin) => {
  const url = `${process.env.REACT_APP_API}/Usuario/Login`;

  const body = {
    login: params.user,
    senha: params.pass,
  };

  const result = await request({
    url,
    noProtect: true,
    method: "POST",
    data: body,
  });

  console.log("Login result:", result);

  if (result.data.token) {
    toast.success("Logado com sucesso");
    return result;
  } else if (result.data.twoFactorRequired) {
    toast.info("Autenticação de dois fatores necessária");
    return result;
  } else {
    toast.error("Usuário ou senha inválidos");
    throw new Error("Login failed");
  }
};

export default login;
